<p-popover #op>
  <div style="font-size: 0.8rem; min-width: 180px; display: flex; flex-direction: column; gap: 2px;">
    <div style="display: flex; justify-content: space-between; align-items: baseline; padding: 4px 0;">
      <span
        style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; color: #999;"
        i18n="@@admin-user"
      >Admin Nutzer</span>
      <span style="font-weight: 700; margin-left: 16px;">{{ this.socketAdminService.connectedAdminsCount() }}</span>
    </div>
    <p-divider class="!my-0" />
    <div style="display: flex; justify-content: space-between; align-items: baseline; padding: 4px 0;">
      <span
        style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; color: #999;"
        i18n="@@admin-connection"
      >Admin Verbindungen</span>
      <span style="font-weight: 700; margin-left: 16px;">{{ this.socketAdminService.connectedAdminSockets() }}</span>
    </div>
    <p-divider class="!my-0" />
    <div style="display: flex; justify-content: space-between; align-items: baseline; padding: 4px 0;">
      <span
        style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; color: #999;"
        i18n="@@user-connection"
      >Nutzer Verbindungen</span>
      <span style="font-weight: 700; margin-left: 16px;">{{ this.socketAdminService.connectedUserSockets() }}</span>
    </div>
    <p-divider class="!my-0" />
    <div style="display: flex; justify-content: space-between; align-items: baseline; padding: 4px 0;">
      <span
        style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; color: #999;"
        i18n="@@liveavatar-connections"
      >Avatar Nova Verbindungen</span>
      <span style="font-weight: 700; margin-left: 16px;">{{ this.socketAdminService.connectedLiveAvatarSessions()
        }}</span>
    </div>
    <p-divider class="!my-0" />
    <div style="padding: 4px 0;">
      <div
        style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; color: #999;"
        i18n="@@version"
      >Version</div>
      <div style="font-weight: 700; margin-top: 2px;">{{ this.APP_VERSION }}</div>
    </div>
  </div>
</p-popover>

<ng-template #projectNav>
  <div>
    <a
      class="nav-link"
      [routerLink]="['/bot-admin']"
      [class.active]="isProjectSection"
      [attr.aria-current]="isProjectSection ? 'page' : null"
    >
      <span class="ms-3 fw-bold"><i class="mx-2 ri-xl ri-folder-line"></i> <ng-container
          i18n="@@projects">Projekte</ng-container></span>
    </a>
  </div>
</ng-template>

<ng-template #separator>
  <hr>
</ng-template>

<ng-template #logo>
  <div class="align-items-center my-5 w-100 text-center project-brand">
    <img
      src="assets/AI_Logo.svg"
      width="32"
      alt="logo"
      (click)="op.toggle($event)"
    >
    <span
      style="color:#a5848f"
      class="fw-bold fs-6 mx-3"
      i18n="@@reflact-ki-toolbox"
    >reflact AI engine</span>
  </div>
</ng-template>

<ng-template #pageHeader>
  <app-page-header [projectOverview]="true"></app-page-header>
</ng-template>
<rag-body-layout
  class="admin-workspace-layout"
  [navItems]="navItems"
  [contentHeaderTpl]="pageHeader"
  [sidebarHeaderTpl]="logo"
>
  <app-provider-status provider="openai"></app-provider-status>
  <app-provider-status provider="elevenlabs"></app-provider-status>
  <app-provider-status provider="did"></app-provider-status>
  <app-provider-status provider="heygen"></app-provider-status>
  <app-provider-status provider="liveavatar"></app-provider-status>
  <app-provider-status provider="falai"></app-provider-status>
  <router-outlet></router-outlet>
</rag-body-layout>